import {
    COUNTRIES_LIST,
    REGIONS_COLLECTION,
    SETTLEMENT_COLLECTION,
} from '@app/pages/clinic/models/country-related.data';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, input, output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectChangeEvent, SelectModule } from 'primeng/select';
import { Subject, distinctUntilChanged, takeUntil } from 'rxjs';

import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabel } from 'primeng/floatlabel';
import { ID_TYPE_LIST } from '@app/pages/clinic/models/static.data';
import { InputTextModule } from 'primeng/inputtext';
import { OwnerForm } from '@app/models/chip.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-owner-form',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        TranslatePipe,
        InputTextModule,
        SelectModule,
        DatePickerModule,
        CheckboxModule,
        FloatLabel
    ],
    templateUrl: './owner-form.component.html',
    styleUrl: './owner-form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OwnerFormComponent implements OnInit, OnDestroy {
    readonly formGroup = input.required<FormGroup<OwnerForm>>();
    readonly isOwnerSearchAvailable = input<boolean>(false);
    readonly searchForOwner = output<void>();

    private destroy$ = new Subject<void>();
    idTypeList = ID_TYPE_LIST;
    countries = COUNTRIES_LIST;
    regions = REGIONS_COLLECTION;
    settlements = SETTLEMENT_COLLECTION;

    ngOnInit(): void {
        this.changeCountry({value: 1});

        this.formGroup().valueChanges
            .pipe(
                distinctUntilChanged(),
                takeUntil(this.destroy$),
            )
            .subscribe(formValue => {
                const { countryId, regionId, settlementId } = formValue;
                if (countryId && regionId ) {
                    this.updateRegionList(countryId);
                }
                if (settlementId && regionId) {
                    this.updateSettlementList(regionId);
                }
            })
    }

    changeCountry({value: countryId}: SelectChangeEvent): void {
        this.updateRegionList(countryId);
        this.changeRegion({value: this.regions[0]?.id});
        this.formGroup().get('regionId')?.setValue(null);
    }

    changeRegion({value: regionId}: SelectChangeEvent): void {
        this.updateSettlementList(regionId);
        this.formGroup().get('settlementId')?.setValue(null);
    }

    updateRegionList(countryId: number): void {
        this.regions = REGIONS_COLLECTION.filter((region) => region.countryId === countryId);
    }

    updateSettlementList(regionId: number): void {
        this.settlements = SETTLEMENT_COLLECTION.filter(
            (settlement) => settlement.regionId === regionId,
        );
    };

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
